import React from 'react';
import './HelpDialog.css';

const HelpDialog = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const upperSectionCategories = [
    { name: 'Ones', description: 'Sum of all 1s', example: 'Three 1s = 3 points' },
    { name: 'Twos', description: 'Sum of all 2s', example: 'Two 2s = 4 points' },
    { name: 'Threes', description: 'Sum of all 3s', example: 'Four 3s = 12 points' },
    { name: 'Fours', description: 'Sum of all 4s', example: 'One 4 = 4 points' },
    { name: 'Fives', description: 'Sum of all 5s', example: 'Three 5s = 15 points' },
    { name: 'Sixes', description: 'Sum of all 6s', example: 'Two 6s = 12 points' },
  ];

  const lowerSectionCategories = [
    { name: 'Three of a Kind', description: 'At least 3 dice of the same value', example: 'Three 4s + any dice = sum of all dice', points: 'Sum of all dice' },
    { name: 'Four of a Kind', description: 'At least 4 dice of the same value', example: 'Four 2s + any die = sum of all dice', points: 'Sum of all dice' },
    { name: 'Full House', description: 'Three of one value and two of another', example: 'Three 3s and two 5s', points: '25 points' },
    { name: 'Small Straight', description: 'Four sequential dice', example: '1-2-3-4 or 2-3-4-5 or 3-4-5-6', points: '30 points' },
    { name: 'Large Straight', description: 'Five sequential dice', example: '1-2-3-4-5 or 2-3-4-5-6', points: '40 points' },
    { name: 'CATZEE', description: 'Five dice of the same value', example: 'Five 6s', points: '50 points' },
    { name: 'Chance', description: 'Any combination', example: 'Any five dice', points: 'Sum of all dice' }
  ];

  return (
    <div className="help-overlay" onClick={onClose}>
      <div className="help-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="help-header">
          <h2>🐱 Catzee Rules 🎲</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="help-content">
          <div className="help-section">
            <h3>How to Play</h3>
            <p>Roll 5 dice up to 3 times per turn. Hold dice you want to keep between rolls. Score in one category per turn.</p>
          </div>

          <div className="help-section">
            <h3>Upper Section</h3>
            <div className="categories-grid">
              {upperSectionCategories.map((category) => (
                <div key={category.name} className="category-item">
                  <div className="category-name">{category.name}</div>
                  <div className="category-description">{category.description}</div>
                  <div className="category-example">{category.example}</div>
                </div>
              ))}
            </div>
            <p className="bonus-info"><strong>Bonus:</strong> Score 35 extra points if your upper section total is 63 or more!</p>
          </div>

          <div className="help-section">
            <h3>Lower Section</h3>
            <div className="categories-grid">
              {lowerSectionCategories.map((category) => (
                <div key={category.name} className="category-item">
                  <div className="category-name">{category.name}</div>
                  <div className="category-description">{category.description}</div>
                  <div className="category-example">{category.example}</div>
                  <div className="category-points">{category.points}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="help-section">
            <h3>Winning</h3>
            <p>Fill all categories for both players. Highest total score wins!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpDialog;